module.exports = "/images/vendor/flag-icon-css/flags/1x1/kz.svg?a19240f60581e10a25ee91cc4c00c3ed";